(() => {
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (_) { return `₹${Math.round(cents / 100)}`; }
  };

  const cardImageSource = (source, card) => {
    try { const url = new URL(source, location.origin); if (url.hostname === location.hostname || url.hostname.endsWith("shopify.com")) url.searchParams.set("width", String(Math.min(900, Math.ceil(card.clientWidth * Math.min(devicePixelRatio || 1, 2))))); return url.toString(); } catch (_) { return source; }
  };

  document.querySelectorAll('[data-fb-product-section]').forEach((section) => {
    const slides = [...section.querySelectorAll('[data-fb-slide]')];
    const thumbs = [...section.querySelectorAll('[data-fb-thumb]')];
    const dots = [...section.querySelectorAll('[data-fb-dot]')];
    const counter = section.querySelector('[data-fb-current-media]');
    let activeMedia = 0;
    let mediaRequest = 0;
    const prepareMedia = async (slide) => {
      const image = slide?.querySelector('img');
      if (!image) return true;
      image.loading = 'eager';
      try { await image.decode(); } catch (_) { return image.complete && image.naturalWidth > 0; }
      return image.naturalWidth > 0;
    };
    const showMedia = async (index) => {
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      activeMedia = index;
      const request = ++mediaRequest;
      const ready = await prepareMedia(slides[index]);
      if (!ready || request !== mediaRequest) return;
      section.querySelector('.fb-product-stage, .fb-pdp-stage')?.classList.remove('is-magnifying');
      section.querySelector('[data-fb-magnify]')?.setAttribute('aria-pressed', 'false');
      slides.forEach((el, i) => {
        const selected = i === index;
        el.classList.toggle('is-active', selected);
        el.setAttribute('aria-hidden', String(!selected));
        if (!selected) el.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((el, i) => el.classList.toggle('is-active', i === index));
      dots.forEach((el, i) => el.classList.toggle('is-active', i === index));
      if (counter) counter.textContent = index + 1;
      if (!navigator.connection?.saveData) {
        [index - 1, index + 1].forEach((next) => {
          const image = slides[(next + slides.length) % slides.length]?.querySelector('img');
          if (image) image.loading = 'eager';
        });
      }
    };
    thumbs.forEach((el, i) => {
      el.addEventListener('click', () => showMedia(i));
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) el.addEventListener('mouseenter', () => showMedia(i));
      el.addEventListener('focus', () => showMedia(i));
    });
    dots.forEach((el, i) => el.addEventListener('click', () => showMedia(i)));
    let touchStart = 0, touchStartY = 0, ignoreTapUntil = 0;
    const stage = section.querySelector('.fb-product-stage, .fb-pdp-stage');
    stage?.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; touchStartY = event.touches[0].clientY; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchStart;
      const verticalDelta = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(delta) < 45 || Math.abs(verticalDelta) > Math.abs(delta) || slides.length < 2) return;
      ignoreTapUntil = performance.now() + 400;
      showMedia(activeMedia + (delta < 0 ? 1 : -1));
    }, { passive: true });
    section.querySelectorAll('[data-fb-gallery-direction]').forEach((button) => button.addEventListener('click', () => {
      showMedia(activeMedia + (button.dataset.fbGalleryDirection === 'next' ? 1 : -1));
    }));
    const gallery = section.querySelector('[data-fb-gallery]');
    let autoplayTimer = null;
    const stopAutoplay = () => { if (autoplayTimer) window.clearInterval(autoplayTimer); autoplayTimer = null; };
    const startAutoplay = () => { stopAutoplay(); };
    gallery?.addEventListener('mouseenter', stopAutoplay);
    gallery?.addEventListener('mouseleave', startAutoplay);
    gallery?.addEventListener('focusin', stopAutoplay);
    gallery?.addEventListener('focusout', (event) => { if (!gallery.contains(event.relatedTarget)) startAutoplay(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stopAutoplay(); else startAutoplay(); });
    startAutoplay();
    const magnify = section.querySelector('[data-fb-magnify]');
    let viewer = null, viewerImage = null, viewerPane = null, previousOverflow = '';
    const openViewer = () => {
      const original = section.querySelector('[data-fb-slide].is-active img');
      if (!original) return;
      if (!viewer) {
        viewer = document.createElement('dialog');
        viewer.className = 'fb-image-viewer';
        viewer.setAttribute('aria-label', 'Enlarged product image');
        viewer.innerHTML = '<div class="fb-image-viewer__toolbar"><span>Product details</span><button type="button" data-viewer-zoom aria-label="Zoom in">+</button><button type="button" data-viewer-fit aria-label="Fit full image">Fit</button><button type="button" data-viewer-close aria-label="Close enlarged image">×</button></div><div class="fb-image-viewer__pane" tabindex="0" aria-label="Product image. Zoom in, then drag or scroll to explore."><img draggable="false" alt=""></div><p>Zoom in, then drag or scroll to explore</p>';
        section.appendChild(viewer);
        viewerImage = viewer.querySelector('img');
        viewerPane = viewer.querySelector('.fb-image-viewer__pane');
        const zoomButton = viewer.querySelector('[data-viewer-zoom]');
        zoomButton.addEventListener('click', () => {
          const zoomed = viewer.classList.toggle('is-zoomed');
          zoomButton.textContent = zoomed ? '−' : '+';
          zoomButton.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
        });
        viewer.querySelector('[data-viewer-fit]').addEventListener('click', () => {viewer.classList.remove('is-zoomed');zoomButton.textContent='+';zoomButton.setAttribute('aria-label','Zoom in');viewerPane.scrollTo(0,0);});
        viewer.querySelector('[data-viewer-close]').addEventListener('click', () => viewer.close());
        viewer.addEventListener('close', () => {document.body.style.overflow=previousOverflow;magnify?.setAttribute('aria-pressed','false');});
        let drag = null;
        viewerPane.addEventListener('pointerdown', event => {if(!viewer.classList.contains('is-zoomed'))return;drag={x:event.clientX,y:event.clientY,left:viewerPane.scrollLeft,top:viewerPane.scrollTop};viewerPane.setPointerCapture(event.pointerId);event.preventDefault();});
        viewerPane.addEventListener('pointermove', event => {if(!drag)return;viewerPane.scrollLeft=drag.left+drag.x-event.clientX;viewerPane.scrollTop=drag.top+drag.y-event.clientY;});
        const endDrag=()=>{drag=null;};viewerPane.addEventListener('pointerup',endDrag);viewerPane.addEventListener('pointercancel',endDrag);
      }
      viewerImage.src = original.src || original.currentSrc;
      viewerImage.alt = original.alt || 'Product image';
      viewer.classList.remove('is-zoomed');
      viewer.querySelector('[data-viewer-zoom]').textContent='+';
      viewer.querySelector('[data-viewer-zoom]').setAttribute('aria-label','Zoom in');
      previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      viewer.showModal();viewerPane.scrollTo(0,0);magnify?.setAttribute('aria-pressed','true');
    };
    magnify?.addEventListener('click', openViewer);
    stage?.addEventListener('click', event => {if(event.target.closest?.('button') || performance.now()<ignoreTapUntil)return;openViewer();});
    section.querySelector('[data-fb-zoom]')?.addEventListener('click',openViewer);

    const form = section.querySelector('.fb-product-form');
    const json = section.querySelector('[data-fb-product-json]');
    if (form && json) {
      const variants = JSON.parse(json.textContent);
      const groups = [...form.querySelectorAll('[data-option-position]')];
      const showVariantMedia = (variant) => {
        const mediaId = variant.featured_media && variant.featured_media.id;
        if (!mediaId) return;
        const index = slides.findIndex((slide) => slide.dataset.fbMediaId === String(mediaId));
        if (index > -1) showMedia(index);
      };
      const initialId = Number(form.querySelector('[data-fb-variant-id]')?.value);
      const initialVariant = variants.find((item) => item.id === initialId);
      if (initialVariant) showVariantMedia(initialVariant);
      groups.forEach((group) => group.querySelectorAll('[data-fb-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-fb-option-value]').forEach((item) => item.classList.remove('is-active'));
          button.classList.add('is-active');
          if (group.querySelector('.fb-pdp-swatches')) section.querySelector('[data-fb-color-name]').textContent = button.dataset.fbOptionValue;
          const selected = groups.map((item) => item.querySelector('[data-fb-option-value].is-active')?.dataset.fbOptionValue);
          const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
          if (!variant) return;
          showVariantMedia(variant);
          form.querySelector('[data-fb-variant-id]').value = variant.id;
          const add = form.querySelector('[data-fb-add]');
          add.disabled = !variant.available;
          add.querySelector('span').textContent = variant.available ? 'Add to bag' : 'Sold out';
          const price = section.querySelector('[data-fb-price]');
          price.querySelector('strong').textContent = money(variant.price);
          const compare = price.querySelector('s');
          const badge = price.querySelector('span');
          const sale = variant.compare_at_price > variant.price;
          compare.hidden = !sale; badge.hidden = !sale;
          if (sale) { compare.textContent = money(variant.compare_at_price); badge.textContent = `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}% OFF`; }
          section.querySelector('[data-fb-sticky-price]').textContent = money(variant.price);
          const sku = section.querySelector('[data-fb-sku]');
          if (sku) sku.textContent = variant.sku || variant.id;
          history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
        });
      }));
      section.querySelector('[data-fb-sticky-submit]')?.addEventListener('click', () => form.requestSubmit(form.querySelector('[data-fb-add]')));
    }
    section.querySelector('[data-fb-pincode-check]')?.addEventListener('click', () => {
      const input = section.querySelector('[data-fb-pincode]');
      const message = section.querySelector('[data-fb-delivery-message]');
      if (!/^\d{6}$/.test(input?.value || '')) {
        message.textContent = 'Please enter a valid 6-digit pincode';
        message.classList.add('is-error');
        return;
      }
      message.textContent = 'Delivery available — usually delivered in 3–5 days';
      message.classList.remove('is-error');
    });
    section.querySelectorAll('[data-fb-tabs]').forEach((tabs) => {
      tabs.querySelectorAll('[data-fb-tab]').forEach((button) => button.addEventListener('click', () => {
        tabs.querySelectorAll('[data-fb-tab]').forEach((item) => item.classList.toggle('is-active', item === button));
        tabs.querySelectorAll('[data-fb-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.fbPanel === button.dataset.fbTab));
      }));
    });
  });

  document.querySelectorAll('[data-fb-product-card]').forEach((card) => {
    const json = card.querySelector('[data-fb-card-variants]');
    const groups = [...card.querySelectorAll('[data-fb-card-option]')];
    if (!json || !groups.length) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    const image = card.querySelector('.fb-card__media > a img');
    const variantInput = card.querySelector('[data-fb-card-variant-id]');
    const price = card.querySelector('[data-fb-card-price]');
    const compare = card.querySelector('[data-fb-card-compare]');
    const selectVariant = () => {
      const selected = groups.reduce((values, group) => {
        values[Number(group.dataset.fbCardOption) - 1] = group.querySelector('[data-fb-card-option-value].is-active')?.dataset.fbCardOptionValue;
        return values;
      }, []);
      const variant = variants.find((item) => item.options.every((value, index) => !selected[index] || value === selected[index]))
        || variants.find((item) => item.available);
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const onSale = variant.compare_at_price > variant.price;
        compare.hidden = !onSale;
        if (onSale) compare.textContent = money(variant.compare_at_price);
      }
      const media = variant.featured_image || variant.featured_media?.preview_image;
      const source = media && (media.src || media.url);
      if (image && source) { image.removeAttribute('srcset'); image.src = cardImageSource(source, card); }
    };
    groups.forEach((group) => group.querySelectorAll('[data-fb-card-option-value]').forEach((button) => {
      const activate = () => {
        group.querySelectorAll('[data-fb-card-option-value]').forEach((item) => item.classList.toggle('is-active', item === button));
        if (image && button.dataset.fbCardOptionImage) { image.removeAttribute('srcset'); image.src = cardImageSource(button.dataset.fbCardOptionImage, card); }
        selectVariant();
      };
      button.addEventListener('click', activate);
      if (group.classList.contains('fb-card__variant-row--colors')) button.addEventListener('mouseenter', activate);
    }));
  });

  const closeFilterDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelector(`[data-fb-filter-toggle="#${drawer.id}"]`)?.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('.fb-filter-drawer.is-open')) document.documentElement.classList.remove('fb-filter-open');
  };
  document.querySelectorAll('.fb-filter-drawer').forEach(closeFilterDrawer);
  document.querySelectorAll('[data-fb-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
    const drawer = document.querySelector(button.dataset.fbFilterToggle);
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('fb-filter-open');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.querySelector('.fb-filter-drawer__head button')?.focus();
  }));
  document.querySelectorAll('[data-fb-filter-close]').forEach((button) => button.addEventListener('click', () => closeFilterDrawer(button.closest('.fb-filter-drawer'))));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFilterDrawer(document.querySelector('.fb-filter-drawer.is-open'));
  });
  document.querySelectorAll('[data-fb-sort]').forEach((select) => select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url.toString());
  }));
  document.querySelectorAll('[data-fb-sort-value]').forEach((button) => button.addEventListener('click', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', button.dataset.fbSortValue);
    window.location.assign(url.toString());
  }));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-fb-mobile-sort][open]').forEach((sort) => {
      if (!sort.contains(event.target)) sort.removeAttribute('open');
    });
  });
  const selectedColors = new URLSearchParams(window.location.search).getAll('filter.v.option.color');
  document.querySelectorAll('[data-fb-color-filter]').forEach((input) => { input.checked = selectedColors.includes(input.value); });
  document.querySelectorAll('[data-fb-catalog]').forEach((catalog) => {
    const filterToggle = catalog.querySelector('[data-fb-sidebar-toggle]');
    const sidebar = catalog.querySelector('.fb-filter-sidebar');
    filterToggle?.addEventListener('click', () => {
      const open = filterToggle.getAttribute('aria-expanded') !== 'true';
      sidebar.hidden = !open;
      catalog.classList.toggle('is-filter-visible', open);
      filterToggle.setAttribute('aria-expanded', String(open));
      filterToggle.querySelector('span').textContent = open ? 'Hide filters' : 'Show filters';
    });

    const grid = catalog.querySelector('[data-fb-product-grid]');
    const colButtons = [...catalog.querySelectorAll('[data-fb-cols]')];
    const markCols = () => {
      const count = grid ? getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length : 0;
      colButtons.forEach((item) => {
        const active = Number(item.dataset.fbCols) === count;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    };
    const setCols = (cols, save) => {
      if (!grid) return;
      if (cols) grid.dataset.cols = cols; else delete grid.dataset.cols;
      if (save) { try { localStorage.setItem('fb-cols', cols); } catch (_) { /* storage blocked */ } }
      markCols();
    };
    let savedCols = null;
    try { savedCols = localStorage.getItem('fb-cols'); } catch (_) { /* storage blocked */ }
    setCols(savedCols, false);
    colButtons.forEach((button) => button.addEventListener('click', () => setCols(button.dataset.fbCols, true)));
    window.addEventListener('resize', markCols, { passive: true });
    catalog.querySelectorAll('[data-fb-view]').forEach((button) => button.addEventListener('click', () => {
      const listView = button.dataset.fbView === 'list';
      grid?.classList.toggle('is-list', listView);
      catalog.querySelectorAll('[data-fb-view]').forEach((item) => item.classList.toggle('is-active', item === button));
    }));
  });

  document.querySelectorAll('[data-fb-collection-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-fb-collection-track]');
    const previous = slider.querySelector('[data-fb-collection-direction="prev"]');
    const next = slider.querySelector('[data-fb-collection-direction="next"]');
    if (!track || !previous || !next) return;

    const updateArrows = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };

    slider.querySelectorAll('[data-fb-collection-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.fbCollectionDirection === 'next' ? 1 : -1;
        track.scrollBy({ left: track.clientWidth * 0.72 * direction, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(updateArrows).observe(track);

    const active = track.querySelector('.fb-collection-circle.is-active');
    if (active) {
      track.scrollLeft = Math.max(0, active.offsetLeft - track.clientWidth / 2 + active.clientWidth / 2);
    }
    updateArrows();
  });
  document.querySelectorAll('form.fb-facets').forEach((form) => {
    const min = form.querySelector('[name="filter.v.price.gte"]');
    const max = form.querySelector('[name="filter.v.price.lte"]');
    const validate = () => {
      const reversed = min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
      max?.setCustomValidity(reversed ? 'Maximum price must be greater than or equal to minimum price.' : '');
    };
    min?.addEventListener('input', validate);
    max?.addEventListener('input', validate);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      validate();
      if (!form.reportValidity()) return;
      const url = new URL(form.action, location.origin);
      for (const [name, value] of new FormData(form)) {
        if (typeof value === 'string' && value.trim() !== '') url.searchParams.append(name, value.trim());
      }
      url.hash = document.querySelector('[data-fb-product-grid]')?.id || '';
      const submit = form.querySelector('[type="submit"]');
      if (submit) { submit.disabled = true; submit.textContent = 'Loading results…'; }
      location.assign(url.toString());
    });
  });

})();
